import { connect } from 'react-redux';
import { RootState, Dispatch } from 'shared/state';
import {
  selectVersionHistoryOpen,
  closeVersionHistoryDialog,
} from 'shared/state/ducks/ui';
import VersionHistoryDialog from './VersionHistoryDialog';
import {
  fetchPagesByTime,
  saveSite,
  updateCurrentPage,
  updateSite,
} from 'shared/state/ducks/sites';
import { saveSitePages } from 'shared/state/ducks/site';
import {
  selectAllSiteVersions,
  selectSiteVersionsPending,
} from 'shared/state/ducks/siteVersions';

const mapStateToProps = (state: RootState) => ({
  open: selectVersionHistoryOpen()(state),
  siteVersionHistory: state.sitePublishedMessages.data.sitePublishedMessages,
  allSiteVersions: selectAllSiteVersions(state),
  siteVersionsPending: selectSiteVersionsPending(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClose: () => {
    dispatch(closeVersionHistoryDialog());
  },
  updateSite: (siteId: number, site: Site) => {
    dispatch(updateSite(siteId, site));
  },
  fetchPagesByTime: (siteId: number, time: number) => {
    dispatch(fetchPagesByTime(siteId, time));
  },
  updateCurrentPage: (siteId: number, pageVersion: PageVersion) => {
    dispatch(updateCurrentPage(siteId, pageVersion));
  },
  saveSite: (siteId: number) => {
    dispatch(saveSite(siteId));
  },
  saveSitePages: (pages: Array<Page>) => {
    dispatch(saveSitePages(pages));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VersionHistoryDialog);
